import React, {useState} from 'react'
import Header from '../components/Header'
import Container from '../components/Content'
import Footer from '../components/Footer'

const IndexPage = () => {

    const [result, setResult] = useState(false)

    return (
        <>
            <Header setResult={setResult} />
            <Container setResult={setResult} result={result}/>
            <Footer/>
        </>
    )
}


export default IndexPage